import { useEffect, useState } from 'react'
import { io } from 'socket.io-client'

export const useElectionsSocket = (url) => {
  const [updates, setUpdates] = useState([])
  const [electionData, setElectionData] = useState(null)

  useEffect(() => {
    const socket = io(url)

    socket.emit('elections', (data) => {
      console.log('Elections Data:', data)
      setElectionData(data)
    })

    socket.on('update', (data) => {
      //console.log('Received change:', data)
      setUpdates((prevUpdates) => [...prevUpdates, data])
    })

    return () => {
      socket.disconnect()
    }
  }, [url])

  return { updates, electionData }
}

export default useElectionsSocket
